import Vue from "vue";
import VueRouter from "vue-router";
import {
	clearCookies,
	getToken,
	checkTokenExpiry,
	checkAndSetAccess,
} from "../utils/tokenCheck.js";
import store from "../store";
import Layout from "../views/layout/Layout";
import jwt_decode from "jwt-decode";
import LayoutNoSidebar from "@/views/layout/LayoutNoSidebar.vue";
import NoSideBarMain from "@/components/Layout/NoSideBarMain.vue";
import { registerPlugin, Capacitor } from "@capacitor/core";
import posthog from 'posthog-js';
import {
	fakeToken,
	userInfo,
	getProfileCompletion,
	getCandInfo,
	getCandidatePrimaryProfile,
	getAllProfiles,
	checkCandidateSignin,
	getCandidateOnboard,
} from "../utils/apiFunctions.js";

const NotificationPlugin = registerPlugin("NotificationPlugin");
import { getProcessedToken } from "../utils/request.js";
import EventBus from "../utils/EventBus.js";
import { resetPrerenderReady } from "../utils/prerender.js";
import { config } from "@/config/index.js";
Vue.use(VueRouter);

// Clear uuid from localStorage once signup is complete
EventBus.$on("signup-complete", () => {
	localStorage.removeItem("uuid");
});

export const routes = [
	{
		path: "/404",
		component: LayoutNoSidebar,
		children: [
			{
				path: "/",
				name: "PageNotFound",
				component: () => import("@/views/error/PageNotFound"),
			},
		],
	},
	{
		path: "/loader",
		component: LayoutNoSidebar,
		children: [
			{
				path: "/",
				name: "LoaderPage",
				component: () => import("@/components/fixedcomponents/LoaderPage.vue"),
			},
		],
	},
	{
		path: "/redirect",
		component: NoSideBarMain,
		children: [
			{
				path: "/",
				name: "AssessmentRedirect",
				component: () =>
					import("@/views/AssessmentProgress/AssessmentRedirect.vue"),
				meta: {
					title: "Assessments",
				},
			},
		],
	},
	{
		path: "/reschedule-request-action",
		component: NoSideBarMain,
		children: [
			{
				path: "/",
				name: "InterviewDetails",
				component: () => import("@/views/InterviewDetails.vue"),
			},
		],
	},
	{
		path: "/verification",
		component: NoSideBarMain,
		children: [
			{
				path: "/",
				name: "IdCapture",
				component: () => import("@/views/cvs/IdCapture.vue"),
			},
		],
	},
	{
		path: "/submitted",
		component: NoSideBarMain,
		children: [
			{
				path: "/",
				name: "CvsSubmitted",
				component: () => import("@/views/cvs/CvsSubmitted.vue"),
			},
		],
	},

	{
		path: "/forgot",
		name: "Forgot",
		component: () => import("../views/login/Forgotpassword.vue"),
	},
	{
		path: "/notifications",
		name: "Notifications",
		component: () => import("../components/Notifications.vue"),
	},
	{
		path: "/login",
		name: "Login",
		meta: {
			title: "Login",
		},
		component: () => import("@/views/login/LoginPage.vue"),
	},
	{
		path: "/register",
		name: "Register",
		meta: {
			title: "Register",
		},
		component: () => import("@/views/login/RegisterPage.vue"),
	},
	{
		path: "/verify-otp",
		name: "OTPVerification",
		meta: {
			title: "Verify OTP",
		},
		component: () => import("@/views/login/OTPVerification.vue"),
	},
	{
		path: "/reset",
		name: "reset",
		meta: {
			title: "Reset Password",
		},
		component: () => import("@/views/login/ResetPassword.vue"),
	},
	{
		path: "/form",
		name: "Form",
		meta: {
			title: "Form",
		},
		component: () => import("@/views/Dashboard/Form.vue"),
	},
	{
		path: "/mobileform",
		name: "MobileForm",
		meta: {
			title: "MobileForm",
		},
		component: () => import("@/views/Dashboard/MobileForm.vue"),
	},
	{
		path: "/paneldashboard",
		component: Layout,
		redirect: "/paneldashboard",
		children: [
			{
				path: "/",
				name: "PanelDashboard",
				component: () => import("../views/PanelDashboard/PanelDashboard.vue"),
				meta: {
					title: "PanelDashboard",
				},
			},
			{
				path: "/panelinterviews/:level",
				name: "PanelInterviews",
				component: () =>
					import("../views/PanelDashboard/MobInterviewRequestCard.vue"),
				meta: {
					title: "PanelInterviews",
				},
			},
			{
				path: "/upcominginterview",
				name: "UpcomingInterview",
				component: () => import("../views/PanelDashboard/MobUpcomingCard.vue"),
				meta: {
					title: "UpcomingInterview",
				},
			},
			{
				path: "/recentinterview",
				name: "RecentInterview",
				component: () =>
					import("../views/PanelDashboard/MobRecentInterviewCard.vue"),
				meta: {
					title: "RecentInterview",
				},
			},

			{
				path: "/viewallinterviews",
				name: "ViewAllInterviews",
				component: () =>
					import("../views/PanelDashboard/ViewAllInterviews.vue"),
				meta: {
					title: "ViewAllInterviews",
				},
			},
			{
				path: "/jobdetails",
				name: "JobDetails",
				component: () => import("../views/PanelDashboard/JobDetailsMob.vue"),
				meta: {
					title: "JobDetails",
				},
			},
			{
				path: "/givefeedback",
				name: "GiveFeedback",
				component: () =>
					import("@/components/PanelDashboardModals/GiveFeedback.vue"),
				meta: {
					title: "GiveFeedback",
				},
			},
			{
				path: "/viewfeedback",
				name: "ViewFeedback",
				component: () =>
					import("../views/PanelDashboard/modals/ViewFeedbackModal.vue"),
				meta: {
					title: "ViewFeedback",
				},
			},
		],
	},
	{
		path: "/profile",
		component: Layout,
		redirect: "/profile",
		children: [
			{
				path: "/",
				name: "MainProfile",
				component: () => import("@/views/routings/profile.vue"),
				meta: {
					title: "Account Settings",
				},
			},
			{
				path: "/testdetails",
				name: "GuestTestDetails",
				component: () => import("@/views/TestDetails.vue"),
			},
			{
				path: "/prepareinterview",
				name: "PrepareInterview",
				component: () => import("@/views/MyProfile/PrepareInterview.vue"),
			},
			{
				path: "/interview",
				name: "InterviewKickstart",
				meta: {
					title: "Practice Interviews",
				},
				component: () =>
					import(
						/* webpackPreload: true */
						"@/views/MyProfile/InterviewKickstart.vue"
					),
			},
			{
				path: "/interviewskill",
				name: "InterviewSkills",
				component: () => import("@/views/MyProfile/InterviewSkills.vue"),
			},
			{
				path: "/aiinterview",
				name: "TakeAiInterview",
				component: () => import("@/views/AiInterview/TakeAiInterview.vue"),
			},
			{
				path: "/skillsinterview",
				name: "AiSkillInterview",
				component: () => import("@/views/AiInterview/AiSkillInterview.vue"),
			},
			{
				path: "/interviewongoing/:interviewID",
				name: "InterviewOngoing",
				component: () => import("@/views/AiInterview/AiInterviewOngoing.vue"),
			},
			{
				path: "/mockinterviewreports",
				name: "ReportAiInterview",
				component: () => import("@/views/AiInterview/ReportAiInterview.vue"),
			},
			{
				path: "/particularmockinterviewreport",
				name: "Report",
				component: () => import("@/views/AiInterview/Report.vue"),
			},
			{
				path: "disabledaccount",
				name: "AccountDisabled",
				meta: {
					title: "View Profile",
				},
				component: () => import("@/views/AccountDisabled.vue"),
			},
			{
				path: "/profilevisibility",
				name: "ProfileVisibility",
				component: () => import("@/views/MyProfile/ProfileVisibility.vue"),
			},
			{
				path: "/assessmentreport",
				name: "AssessmentReport",
				component: () =>
					import("@/views/AssessmentProgress/AssessmentReport.vue"),
			},
			{
				path: "/streaks",
				name: "streaks",
				component: () => import("@/views/Streaks/StreakPage.vue"),
			},
		],
	},

	{
		path: "/job",
		component: Layout,
		children: [
			{
				path: "/",
				redirect: "search",
			},
			{
				path: "search",
				name: "JobSearch",
				component: () =>
					import(/* webpackPreload: true */ "@/views/routings/jobSearch.vue"),
				meta: {
					title: "Job Search",
				},
			},
			{
				path: "/jobinfo",
				name: "GuestJobDetails",
				component: () => import("@/views/guest/GuestJobDetails.vue"),
				meta: {
					title: "Job Details",
				},
			},
			{
				path: "progress",
				name: "JobProgress",
				component: () => import("@/views/routings/jobProgress.vue"),
				meta: {
					title: "Applied Jobs",
				},
			},
			{
				path: "jobpref",
				name: "JobPreference",
				component: () => import("@/views/JobSearch/MobileJobpref.vue"),
				meta: {
					title: "Job Preference",
				},
			},
			{
				path: "jobmatch",
				name: "JobMatch",
				component: () => import("@/components/JobSearch/JobMatch.vue"),
				meta: {
					title: "Job Match",
				},
				props: true,
			},
		],
	},
	{
		path: "/assessment",
		component: Layout,
		children: [
			{
				path: "marketplace",
				name: "AssessmentMarketplace",
				meta: {
					title: "Assessments",
				},
				component: () =>
					import(
						/* webpackPreload: true */
						"@/views/AssessmentProgress/Categories.vue"
					),
			},
			{
				path: "progress",
				name: "CandidateAssessmentProgress",
				meta: {
					title: "Assessments",
				},
				component: () =>
					import("@/views/AssessmentProgress/LaptopAssessmentProgress.vue"),
			},
			{
				path: "toAssessmentWeb",
				name: "TestDetails",
				component: () => import("@/views/AssessmentProgress/TestDetailsAP.vue"),
				meta: {
					title: "Assessments",
				},
			},
			{
				path: "toAssessment",
				name: "mobAssessment",
				component: () =>
					import("@/views/AssessmentProgress/TestDetailsMobile.vue"),
				meta: {
					title: "Assessments",
				},
			},
			{
				path: "viewMarks",
				name: "mobViewMarks",
				component: () =>
					import("@/views/AssessmentProgress/MobAssessmentMarks.vue"),
				meta: {
					title: "View Marks",
				},
			},
		],
	},

	{
		path: "/",
		component: LayoutNoSidebar,
		redirect: "/homepage",
		children: [
			{
				path: "homepage",
				name: "Homepage",
				meta: {
					title: "Home Page",
				},
				component: () => import("@/views/NewCandidateDashboard.vue"),
			},
		],
	},

	{
		path: "/",
		component: Layout,
		redirect: "/homepage",
		children: [
			{
				path: "signup",
				name: "Signup",
				meta: {
					title: "Sign Up",
				},
				component: () => import("@/components/Onboarding/Signup.vue"),
			},
			{
				path: "dashboard",
				name: "CandidateDashboard",
				meta: {
					title: "Resume Builder",
				},
				component: () =>
					import(
						/* webpackPreload: true */
						"@/views/Dashboard/components/CandidateDashboard.vue"
					),
			},
			{
				path: "/u/:username",
				name: "ViewPublicProfile",
				meta: {
					title: "View Profile",
				},
				component: () => import("@/views/ViewProfile.vue"),
			},
			{
				path: "documents",
				name: "CandidateDocsList",
				component: () => import("../views/routings/documents.vue"),
				meta: {
					title: "Documents",
				},
			},
			{
				path: "onboardingdocuments",
				name: "OnboardingDocuments",
				component: () =>
					import("../views/CandidateDocuments/Meesho/Documents.vue"),
				meta: {
					title: "Onboarding Documents",
				},
			},
			{
				path: "previewresumemob",
				name: "MobilePreviewResume",
				component: () => import("../views/BuilderPage/PreviewResume.vue"),
				meta: {
					title: "MobilePreviewResume",
				},
			},
			{
				path: "/becomepanelist",
				name: "BecomePanelist",
				meta: {
					title: "BecomePanelist",
				},
				component: () => import("@/views/BecomePanelist.vue"),
			},
			{
				path: "/verifyaccount",
				name: "VerifyAccount",
				meta: {
					title: "VerifyAccount",
				},
				component: () => import("@/views/BecomePanelist/VerifyAccount.vue"),
			},
			{
				path: "/chooseexpertise",
				name: "ChooseExpertise",
				meta: {
					title: "ChooseExpertise",
				},
				component: () => import("@/views/BecomePanelist/ChooseExpertise.vue"),
			},
			{
				path: "/applicationresult",
				name: "ApplicationResult",
				meta: {
					title: "ApplicationResult",
				},
				component: () => import("@/views/BecomePanelist/ApplicationResult.vue"),
			},
			{
				path: "/resultdashboard",
				name: "ResultDashboard",
				meta: {
					title: "ResultDashboard",
				},
				component: () => import("@/views/BecomePanelist/ResultDashboard.vue"),
			},
			{
				path: "instructorresult",
				name: "InstructorResult",
				meta: {
					title: "InstructorResult",
				},
				component: () =>
					import("@/views/BecomeInstructor/InstructorResult.vue"),
			},
			{
				path: "/transaction",
				name: "Transaction",
				meta: {
					title: "Transaction",
				},
				component: () => import("@/views/Transaction/Transaction.vue"),
			},
			{
				path: "/transactionmob",
				name: "TransactionMob",
				meta: {
					title: "Transaction",
				},
				component: () => import("@/views/Transaction/TransactionMob.vue"),
			},
			{
				path: "/becomeinstructor",
				name: "BecomeInstructor",
				meta: {
					title: "BecomeInstructor",
				},
				component: () => import("@/views/BecomeInstructor.vue"),
			},
			{
				path: "/becomeinstructorsurvey",
				name: "BecomeInstructorSurvey",
				meta: {
					title: "BecomeInstructorSurvey",
				},
				component: () => import("@/views/BecomeInsSurvey.vue"),
			},
			{
				path: "/games",
				name: "Games",

				component: () => import("@/views/Games/Games.vue"),
			},
			{
				path: "/leaderboard",
				name: "Leaderboard",

				component: () => import("@/components/Games/LeaderBoard.vue"),
			},
			{
				path: "/singlegame",
				name: "SingleGame",

				component: () => import("@/views/Games/ParentGame.vue"),
			},
			{
				path: "/search",
				name: "Seacrh",
				component: () => import("@/views/MobileSearchSuggestion.vue"),
			},

			{
				path: "mobtask",
				name: "mobtask",
				meta: {
					title: "Mobile task HomePage",
				},
				component: () =>
					import("@/components/MobileComponents/HomePage/Task.vue"),
			},
			{
				path: "mobstreaks",
				name: "mobstreaks",
				meta: {
					title: "Mobile Streaks HomePage",
				},
				component: () =>
					import("@/components/MobileComponents/HomePage/Streaks.vue"),
			},
		],
	},

	{
		path: "/video",
		component: Layout,
		redirect: "/video",
		children: [
			{
				path: "systemcheck",
				name: "systemcheck",
				component: () =>
					import("@/views/Dashboard/components/VideoResume/SystemCheck.vue"),
				meta: {
					title: "System Check",
				},
			},
			{
				path: "snapshot",
				name: "snapshot",
				component: () =>
					import("@/views/Dashboard/components/VideoResume/VideoResumes.vue"),
				meta: {
					title: "Video Snapshot",
				},
			},
			{
				path: "previewvideoresume",
				name: "previewvideoresume",
				component: () =>
					import(
						"@/views/Dashboard/components/VideoResume/PreviewVideoResume.vue"
					),
				meta: {
					title: "Preview Video Resume",
				},
			},
		],
	},

	{ path: "*", redirect: "/404", hidden: true },
];

const createRouter = () => {
	return new VueRouter({
		mode: "history",
		base: "/builder",
		scrollBehavior: () => ({ y: 0 }),
		routes,
	});
};

const router = createRouter();

// reset router
export const resetRouter = () => {
	const newRouter = createRouter();
	router.matcher = newRouter.matcher; // reset router
};

// page title function
const title = "Candidate Portal";
const getPageTitle = (pageTitle) => {
	if (pageTitle) {
		return `${pageTitle} - ${title}`;
	}
	return `${title}`;
};

function populateUserData() {
	store.commit("userVUEX/SET_TOKEN", getToken());
	store.commit("userVUEX/SET_REFRESH_TOKEN", getRefreshToken());
	store.commit("userVUEX/checkLoginStatus", true);
	const decoded = jwt_decode(getToken());
	store.commit("userVUEX/SET_USER_NAME", decoded.given_name);
}

function setLocalStorage(uuid, licenseKey, type) {
	localStorage.setItem("uuid", uuid);
	localStorage.setItem("licenseKey", licenseKey);
	localStorage.setItem("type", type);
}

export const checkAccess = () => {
	if (document.cookie.length > 0) {
		let data = document.cookie.split(";");
		for (let i in data) {
			let cur = data[i].split("=");
			if (cur[0].trim() === "candidate") {
				if (cur[1] === "no-access") {
					return false;
				} else {
					return true;
				}
			}
		}
	}
	return false;
};

const getfakeToken = async () => {
	try {
		const res = await fakeToken();
		if (res.status == 200) {
			localStorage.setItem("faketoken", res.data.token);
		}
	} catch (error) {
		console.error(error);
	}
};

/** If we have a notification redirect, call next() once and return true so guard exits. Otherwise return false. */
const checkAndNavigateToNotification = (next) => {
	const notificationRedirect =
		store.getters["userVUEX/getNotificationRedirect"];
	if (
		notificationRedirect &&
		(notificationRedirect.link != null || notificationRedirect.project != null)
	) {
		const project = notificationRedirect.project;
		const link = notificationRedirect.link;
		store.commit("userVUEX/setNotificationRedirect", null);
		if (project === "Candidate" && link) {
			next({ path: `/${link}`.replace(/\/+/g, "/") });
			return true;
		}
		if (link) {
			window.location.replace("https://candidate.hire3x.com/training" + link);
			return true;
		}
		next();
		return true;
	}
	return false;
};

/** Login route – use for next() in guard or router.push() in components. */
export const LOGIN_ROUTE = { name: "Login" };

/**
 * Navigate to login. Use in router guard: goToLogin(next). Use in components: goToLogin(this.$router).
 * On non-native (web) redirects to external login URL; on native uses the given navigator.
 */
export const goToLogin = (navigator) => {
	if (!Capacitor.isNativePlatform()) {
		window.location.replace(`${config.websiteBase}login`);
		return;
	}
	if (typeof navigator === "function") {
		navigator(LOGIN_ROUTE);
	} else if (navigator && typeof navigator.push === "function") {
		navigator.push(LOGIN_ROUTE);
	}
};

const publicRouteNames = [
	"PageNotFound",
	"Forgot",
	"LoaderPage",
	"IdCapture",
	"ViewPublicProfile",
	"CvsSubmitted",
	"InterviewDetails",
	"GuestJobDetails",
	"AssessmentRedirect",
	"JobSearch",
	// "InterviewKickstart",
	"InterviewSkills",
	"GuestTestDetails",
	"AssessmentMarketplace",
	"CandidateAssessmentProgress",
	"mobAssessment",
];

const loginRouteNames = [
	"Login",
	"Forgot",
	"reset",
	"Register",
	"OTPVerification",
];

/** Normalize notification from plugin: flat { link, project, ... } or Android JSObject nameValuePairs. */
function normalizeNotificationPayload(raw) {
	if (!raw || typeof raw !== "object") return null;
	const data = raw.nameValuePairs || raw;
	if (data.link != null || data.project != null || data.eventName != null)
		return data;
	return null;
}

let isFetchingUserData = false;
let isCandidateSigninChecked = false;

let pageStart = Date.now();

router.beforeEach(async (to, from, next) => {
	console.log(to, "***************");
	// Store uuid from query params before any branching so it's always captured

	if (to.query.downloadReport === "true" || to.query.downloadReport === true) {
		store.commit("userVUEX/setDownloadReport", true);
	}
	if (
		to.query.openResumeClinic === "true" ||
		to.query.openResumeClinic === true
	) {
		store.commit("userVUEX/setShowResumeClinic", true);
	}
	resetPrerenderReady();
	document.title = getPageTitle(to.meta.title);

	// When app was opened from a notification tap (native), read notification data from plugin
	if (Capacitor.isNativePlatform()) {
		try {
			const { notification } =
				await NotificationPlugin.getCurrentNotification();
			console.log("notification", notification);
			if (notification) {
				const raw =
					typeof notification === "string"
						? JSON.parse(notification)
						: notification;
				const payload = normalizeNotificationPayload(raw);
				if (payload) store.commit("userVUEX/setNotificationRedirect", payload);
			}
			await NotificationPlugin.clearCurrentNotification();
		} catch (error) {
			// No current notification or plugin not available
		}
	}

	if (loginRouteNames.includes(to.name)) {
		if (getToken()) {
			next("/");
		} else {
			next();
		}
		return;
	}

	// Allow public routes (Login, Forgot, etc.) without token – prevents redirect loop when going to Login
	if (
		publicRouteNames.includes(to.name) &&
		!to?.query?.interviewPage &&
		!to?.query?.trainingMod
	) {
		if (to.name == "ViewPublicProfile" && to.params.username) {
			await getfakeToken();
			setTimeout(() => {
				next();
			}, 1000);
		} else {
			next();
		}
		return;
	}
	if (!getToken()) {
		goToLogin(next);
		return;
	}

	const interviewFlow = [
		"InterviewSkills",
		"TakeAiInterview",
		"ReportAiInterview",
		"AiSkillInterview",
		"InterviewOngoing",
		"Report",
		"systemcheck",
	];
	if (!interviewFlow.includes(to.name)) {
		store.commit("candidateVUEX/setSavedInterviewSkillState", null);
	}
	// set page title
	document.title = getPageTitle(to.meta.title);
	localStorage.setItem("currentPage", to.name);
	if (checkAndNavigateToNotification(next)) return;
	checkAndSetAccess();
	// determine whether the user has logged in
	if (to.name == "AccountDisabled" || to.name == "IdCapture" || to.name == 'CvsSubmitted' || to.name == 'InterviewDetails' || to.name == 'AssessmentRedirect') {
		next();
	} else if (checkAccess()) {
		const hasToken = getToken();
		if (hasToken) {
			const userID = getProcessedToken();
			// if (to?.query?.uuid) {
			// 	store.commit("userVUEX/SET_RESUME_UUID", to.query.uuid);
			// }
			if (to?.query?.uuid) {
				localStorage.setItem("uuid", to.query.uuid);
			}
			if (userID && !isCandidateSigninChecked && to.name !== "MobileForm") {
				isCandidateSigninChecked = true;
				try {
					// Step 1: check onboarding status first
					const onboardRes = await getCandidateOnboard();
					const onboardData = onboardRes?.data?.data;
					console.log(
						"[Onboarding][router] getCandidateOnboard response:",
						onboardData
					);

					if (
						onboardData?.onboardingCompleted === true ||
						onboardData?.onboardingCompleted === null
					) {
						// Onboarding already done — skip checkCandidateSignin entirely
						console.log(
							"[Onboarding][router] onboardingStep is completed — skipping checkCandidateSignin"
						);
					} else {
						// Step 2: onboarding not complete — call checkCandidateSignin
						const checkRes = await checkCandidateSignin({
							check_completion: "true",
							userID,
						});
						if (checkRes?.data?.type === "Success") {
							const signinCheckData = checkRes.data.data;
							const isCandVal =
								signinCheckData?.isCandidate ??
								signinCheckData?.iscandidate ??
								signinCheckData?.is_candidate;
							if (isCandVal === false || isCandVal === "false") {
								EventBus.$emit("show-signup-form", { signinCheckData });
							} else {
								// Returning candidate — check if onboarding is still incomplete
								console.log(
									"[Onboarding][router] user is candidate — evaluating onboard step..."
								);
								if (onboardData && onboardData.onboardingCompleted === false) {
									const step = onboardData.onboardingStep;
									console.log(
										"[Onboarding][router] onboardingCompleted: false — step:",
										step
									);
									if (step === "skills" || step === "goals") {
										console.log(
											"[Onboarding][router] emitting show-onboarding-modal with step:",
											step
										);
										store.commit("candidateVUEX/setPendingOnboarding", {
											step,
										});
										EventBus.$emit("show-onboarding-modal", { step });
									} else if (step === "resumeUpload") {
										console.log(
											"[Onboarding][router] resumeUpload step — opening UploadResume"
										);
										sessionStorage.setItem("fromOnboarding", "true");
										store.commit("candidateVUEX/setPendingOnboarding", {
											step: "resumeUpload",
										});
										EventBus.$emit("show-onboarding-modal", {
											step: "resumeUpload",
										});
									} else {
										console.log(
											"[Onboarding][router] unknown step — opening from WelcomeStep"
										);
										store.commit("candidateVUEX/setPendingOnboarding", {
											step: null,
										});
										EventBus.$emit("show-onboarding-modal");
									}
								} else {
									console.log(
										"[Onboarding][router] onboardingCompleted: true — no modal"
									);
								}
							}
						}
					}
				} catch (err) {
					console.error("[Onboarding][router] error:", err);
				}
			}
			if (
				from.name != null &&
				from.name == "CandidateDashboard" &&
				to.name != "MobileForm" &&
				to?.query?.type != "resumeClinic"
			) {
				store.commit(
					"candidateVUEX/setCandidateInfo",
					store.getters["candidateVUEX/getPrimaryCandidateInfo"]
				);
			}
			store.commit("userVUEX/checkLoginStatus", true);
			localStorage.setItem("accessToken", getToken());
			const isCandidate = Array.isArray(to.query.from)
				? to.query.from.includes("candidate")
				: to.query.from === "candidate";
			if (isCandidate && !isFetchingUserData) {
				// Fetch user and candidate information only when coming from login
				isFetchingUserData = true; // Set flag to true to prevent multiple calls


				try {
					const respData = await getCandidatePrimaryProfile();
					if (respData.status === 200) {
						store.commit("candidateVUEX/setPrimaryProfile", respData.data.data);
					}
					// Fetch user information
					const res = await userInfo();
					if (res.status === 200) {
						//clear old data in candidateInfo if any exists
						if (
							store.getters["candidateVUEX/getcandidateInfo"] &&
							store.getters["candidateVUEX/getcandidateInfo"].userID !==
								res.data.data.userID
						) {
							store.commit("candidateVUEX/setCandidateInfo", {});
						}
						store.commit("userVUEX/setUserInfo", res.data.data);
						console.log(res.data.data);

						posthog.identify(res.data.data.userID, {
							email: res.data.data.email,
							displayName: res.data.data.displayName,
							username: res.data.data.username,
						});
						posthog.capture("user_identified", {
							email: res.data.data.email,
							displayName: res.data.data.displayName,
							username: res.data.data.username,
						});
					}

					// Fetch candidate information
					const resp = await getCandInfo();
					if (resp.status === 200) {
						const candidateInfo = resp.data.data;
						store.commit("candidateVUEX/setCandidateInfo", candidateInfo);

						// Fetch profile completion information
						const res2 = await getProfileCompletion();
						if (res2.status === 200) {
							const candProgressResp = res2.data.data;
							store.commit(
								"candidateVUEX/updateCandidateProgress",
								candProgressResp
							);
							if (candidateInfo.primary) {
								store.commit(
									"candidateVUEX/updateCandidateProgressPrimary",
									candProgressResp
								);
							}
						}
						//job navigations from resume clinic
						if (to.query?.resumeJobid && to.query?.uuid) {
							const res = await getAllProfiles();
							if (res.status === 200) {
								const profiles = res.data.data;
								const resumejobid = to.query.resumeJobid;
								const uuid = to.query.uuid;
								if (profiles.length > 1 && res2.data.data.progress >= 20) {
									return next({
										path: "/job/search",
										query: {
											jobID: resumejobid,
										},
									});
								} else if (
									profiles.length === 1 &&
									res2.data.data.progress < 20
								) {
									return next({
										path: "/dashboard",
										query: {
											uuid: uuid,
										},
									});
								}
							}

							return next();
						}

						// Redirect to myprofile after login

						if (
							!to.query.from === "candidate" &&
							candidateInfo.database_demographics &&
							!to.query.uuid &&
							!to.query.resumeJobid &&
							to.query.type !== "resumeClinic"
						) {
							next({ path: "/homepage" });
							return;
						}
					}
				} catch (error) {
					console.error("Error fetching user or candidate info:", error);
					// Handle error if necessary
				} finally {
					isFetchingUserData = false; // Reset flag
				}
			}

			const expiryTime = checkTokenExpiry();
			if (expiryTime) {
				// if (from.path == '/') {
				//   const res = await userInfo();
				//   if (res.status == 200) {
				//     store.commit("userVUEX/setUserInfo", res.data.data);
				//   }
				// }
				isCandidateSigninChecked = false;
				let loginStatus = store.getters.checkLoginStatus;
				if (localStorage.getItem("uuid") && !loginStatus) {
					populateUserData();
					let type = localStorage.getItem("type");
					let query = {
						uuid: localStorage.getItem("uuid"),
						type: localStorage.getItem("type"),
						licenseKey: localStorage.getItem("licenseKey"),
					};
					if (type == "offer") {
						next({ path: "previewofferletter", query: query });
					} else {
						next({ path: "employeeregistration", query: query });
					}
					if (to.meta.title != "Login") {
						next(false);
					}
					return { name: "CandidateDashboard" };
				} else if (!loginStatus) {
					populateUserData();
					next();
				} else {
					next();
				}
			} else {
				store.commit("candidateVUEX/setCandidateInfo", {});
				localStorage.clear();
				if (to.query.uuid) {
					setLocalStorage(to.query.uuid, to.query.licenseKey, to.query.type);
				}
				store.dispatch("userVUEX/LogOut");
			}
		} else {
			/* has no token*/
			if (to.query.uuid) {
				setLocalStorage(to.query.uuid, to.query.licenseKey, to.query.type);
			}
			clearCookies();
			goToLogin(next);
		}
	} else if (
		to.name == "jobsearch" ||
		to.name == "particularjobdetails" ||
		to.name == "particularjob"
	) {
		// store.commit('userVUEX/setLoginStatus' , false);
		console.log(document.cookie);
		next();
	} else if (to.name != "ViewPublicProfile") {
		const resumejobid = to.query.jobID;
		const uuid = to.query.uuid;
		if (resumejobid && uuid) {
			goToLogin(next);
		} else {
			clearCookies();
			goToLogin(next);
		}
	}
});

export default router;
